import { api } from "../lib/axios";
import { StationFormData } from "../schemas/station";

export const createStation = async (data: StationFormData) => {
  const response = await api.post(`/station`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return response.data;
};

export const getStation = async (id: string) => {
  const response = await api.get(`/station/${id}`);
  return response.data;
};

export const getStationInfo = async (id: string) => {
  const response = await api.get(`/station/info/${id}`);
  return response.data;
};

export const getStationQrCode = async (id: string) => {
  const response = await api.get(`/station/${id}/qrcode`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return response.data;
};

export const getAllStations = async () => {
  const response = await api.get(`/station/`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return response.data;
};

export const updateStation = async (id: string, data: StationFormData) => {
  const response = await api.put(`/station/${id}`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return response.data;
};

export const deleteStation = async (id: number) => {
  const response = await api.delete(`/station/${id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return response.data;
};
